import { SVGProps, Ref, forwardRef } from 'react';

export const EmojiSadFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 .5C1.438.5.5 1.438.5 8s.938 7.5 7.5 7.5 7.5-.937 7.5-7.5S14.563.5 8 .5M6.032 12.497c0-.278.113-.556.343-.8.34-.363.923-.633 1.623-.633s1.283.27 1.623.632c.23.245.343.523.343.8h1.4c0-.681-.284-1.29-.723-1.758-.632-.674-1.599-1.074-2.643-1.074s-2.01.4-2.643 1.074c-.44.468-.723 1.077-.723 1.759zm-1.7-5.465h2.666v-1.4H4.332zm7.332 0H8.998v-1.4h2.666z"
                fill="currentColor"
            />
        </g>
    </svg>
));
EmojiSadFilledSize16Glyph.displayName = 'EmojiSadFilledSize16Glyph';
